export default "__VITE_ASSET__0e6eb718__"